// removed by extract-text-webpack-plugin
module.exports = {"fixed-price-toggle":"FixedPriceToggle__fixed-price-toggle___2lf0R","loading":"FixedPriceToggle__loading___18bkJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FixedPriceToggle/FixedPriceToggle.css
// module id = 702
// module chunks = 0